// ─── Shared rules for admin-entered names (roles, organizations) ────

/** Reason a name was rejected — maps to a user-facing message per surface. */
export type NameProblem = 'required' | 'tooShort' | 'tooLong' | 'noLetter' | 'markup';

/** Unicode-aware: any letter in any script (Hebrew, Arabic, CJK…) satisfies the check. */
const LETTER_PATTERN = /\p{L}/u;
/** Angle brackets only ever appear in pasted markup, never in a real name. */
const MARKUP_PATTERN = /[<>]/;

/** Returns the first reason a name is invalid, or `null`. Operates on the trimmed value. */
export function checkNameRules(name: string, limits: { min: number; max: number }): NameProblem | null {
  const trimmed = name.trim();
  if (trimmed.length === 0) return 'required';
  if (trimmed.length < limits.min) return 'tooShort';
  if (trimmed.length > limits.max) return 'tooLong';
  if (!LETTER_PATTERN.test(trimmed)) return 'noLetter';
  if (MARKUP_PATTERN.test(trimmed)) return 'markup';
  return null;
}

export const NO_LETTER_MESSAGE =
  "Include at least one letter. Names made only of emoji or numbers can't be searched or read aloud.";
